import { ButtonGroup } from '@vds/buttons';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { isIOS, isAndroid } from "react-device-detect";
import common from '../../utilities/util';

const FooterWrapper = styled.div`
 position: -webkit-sticky;
 position: -moz-sticky;
 position: -o-sticky;
 position: -ms-sticky;
 position: sticky;
 ${props => props.isExtraPadding ? `padding: 0 20px;` : `padding: 0;`}
 bottom: 0px;
 ${props => props.showButtonAbsolute ? `position:absolute;width:92%;`: ``}
 ${props => props.showBorderTop || props.channelId == "VZW-DOTCOM" ? `` : `border-top: 1px solid #d8dada;`}
 padding-top: 20px;
 background: #fff;
 ${props => props.cdPlanSelection ? `margin: 0 -20px;` : ``}
 padding-bottom: 8px;
`;

const ButtonWrapper = styled.div`
    ${props => props.hasTwoButtons
    ? `padding-left: 16px; padding-right: 4px; margin: 0 -20px;`
    : `width: 180px; margin: 0 auto; padding-bottom:12px;`}
    ${props => props.showLargeBtn ? `min-width: 220px;` : ''}
    ${props => props.channelId == "VZW-DOTCOM" ? `margin: initial;` : ``}

       ${props => props.hasExceededLength ? `button {font-size: 13px; white-space: normal;}` : ``}
       ${props => props.vdsLargeButton ? `button {font-size: 16px; white-space: normal;}` :`` }

`
const VDSButtonWrapper = ({ primaryButtonText, onPrimaryButtonClick, primaryButtonAnalytics, primaryButtonClickStream, secondaryButtonText, onSecondaryButtonClick, secondaryButtonAnalytics, secondaryButtonClickStream, primaryTextDisabled, secondaryTextDisabled, footerClass, showBorderTop, isExtraPadding, cdPlanSelection, showTwoButtonParallely,showButtonReverse, dataBoostComp, showLargeBtn, primaryButtonId, secondaryButtonId,showButtonAbsolute}) => {
  let data = [];
  let colQuantity = { desktop: 2, tablet: 2, mobile: 1, }
  let primaryButtonTextLength = primaryButtonText && primaryButtonText.length;
  let secondaryButtonTextLength = secondaryButtonText && secondaryButtonText.length;
  let osType = common.getOsType(isIOS, isAndroid);
  let channelId = common.getChannelId();
  const showTwoButtonParallel= showTwoButtonParallely
  const showButtonRev = showButtonReverse
  const borderTop = dataBoostComp;
  const vdsLargeButton = dataBoostComp;
  
  if (secondaryButtonText) {
    data.push(
      {
        children: secondaryButtonText,
        id: secondaryButtonId,
        size: 'large',
        buttonType: 'secondary',
        "data-clickstream": secondaryButtonClickStream,
        "data-analyticstrack": secondaryButtonAnalytics,
        "data-track": secondaryButtonAnalytics,
        onClick: onSecondaryButtonClick,
        disabled: secondaryTextDisabled && secondaryTextDisabled !== "undefined" ? true : false
      }
    )
  }

  if (primaryButtonText) {
    data.push(
      {
        children: primaryButtonText,
        size: 'large',
        buttonType: 'primary',
        id: primaryButtonId,
        "data-clickstream": primaryButtonClickStream,
        "data-analyticstrack": primaryButtonAnalytics,
        "data-track": primaryButtonAnalytics,
        onClick: onPrimaryButtonClick,
        disabled: primaryTextDisabled && primaryTextDisabled !== "undefined" ? true : false
      }
    )
  }

  return (
    <Fragment>
      <FooterWrapper showButtonAbsolute={showButtonAbsolute ? showButtonAbsolute : false} channelId={channelId} channelType={osType} showBorderTop={showBorderTop ? showBorderTop : false} isExtraPadding={isExtraPadding ? isExtraPadding : false} cdPlanSelection={cdPlanSelection ? true : false} className="vdsFooterMainWrapper">
        <ButtonWrapper channelId={channelId} hasTwoButtons={primaryButtonText && secondaryButtonText} showLargeBtn={showLargeBtn ? showLargeBtn : false} hasExceededLength={(primaryButtonTextLength > 11 || secondaryButtonTextLength > 11) && !showTwoButtonParallel} className={footerClass ? footerClass : ""}>
          {!showTwoButtonParallel && (
            <ButtonGroup childWidth={'100%'}
              colQuantity={colQuantity}
              data={data}
            />
           )}
          {showTwoButtonParallel &&(
            <ButtonGroup
              childWidth={'100%'}
              viewport={'mobile'}
              rowQuantity={{ mobile: 1 }}
              data={ showButtonRev ? data.reverse(): data}
            />
          )}
          

        </ButtonWrapper>



      </FooterWrapper>
    </Fragment>
  );
};

export default VDSButtonWrapper;